import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitEnquiry = (payload) =>
  axios.post(`${API}/enquiries`, payload).then((r) => r.data);

export const getReviews = () => axios.get(`${API}/reviews`).then((r) => r.data);

export const uploadPhoto = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/upload`, fd).then((r) => r.data);
};
